import { useState, useCallback } from 'react';
import { ClipboardDocumentIcon, CheckIcon } from '@heroicons/react/24/outline';

/**
 * Small inline copy-to-clipboard button.
 * Shows a clipboard icon; briefly flashes a checkmark after copying.
 */
export default function CopyButton({ text, className = '' }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback((e) => {
    e.stopPropagation();
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    });
  }, [text]);

  if (!text) return null;

  const Icon = copied ? CheckIcon : ClipboardDocumentIcon;
  const color = copied ? 'text-green-400' : 'text-gray-500 hover:text-gray-300';

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={`inline-flex items-center p-0 ml-1 opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity cursor-pointer ${color} ${className}`}
      title={copied ? 'Copied!' : text}
    >
      <Icon className="h-3 w-3" />
    </button>
  );
}
